const CONSENT_MAX_AGE = 60 * 60 * 24 * 365
const DENIED_CONSENT = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied"
}

const state = {
  measurementId: "",
  scriptSrc: "",
  consentCookie: "",
  consent: "",
  gtagReady: false,
  configured: false,
  scriptLoaded: false,
  turboBound: false
}

export function initGoogleAnalytics({ measurementId, scriptSrc, consentCookie, consent }) {
  state.measurementId = measurementId
  state.scriptSrc = scriptSrc
  state.consentCookie = consentCookie
  state.consent = consent || readCookie(consentCookie)

  bindTurboPageviews()

  if (currentConsent() === "granted") loadAndGrant()
}

export function acceptAnalytics() {
  writeConsent("granted")
  loadAndGrant()
  pageview()
}

export function rejectAnalytics() {
  writeConsent("denied")
  clearGoogleCookies()
}

function currentConsent() {
  return state.consent || readCookie(state.consentCookie)
}

function bindTurboPageviews() {
  if (state.turboBound || typeof document === "undefined") return

  state.turboBound = true
  document.addEventListener("turbo:load", pageview)
}

function ensureGtagStub() {
  if (state.gtagReady) return

  window.dataLayer = window.dataLayer || []
  if (typeof window.gtag !== "function") {
    window.gtag = function () {
      window.dataLayer.push(arguments)
    }
  }
  window.gtag("consent", "default", DENIED_CONSENT)
  state.gtagReady = true
}

function loadAndGrant() {
  if (!state.measurementId || !state.scriptSrc) return

  ensureGtagStub()
  window.gtag("consent", "update", { analytics_storage: "granted" })

  if (!state.configured) {
    window.gtag("js", new Date())
    window.gtag("config", state.measurementId, {
      anonymize_ip: true,
      send_page_view: false
    })
    state.configured = true
  }

  if (!state.scriptLoaded) {
    const script = document.createElement("script")
    script.async = true
    script.src = state.scriptSrc
    script.setAttribute("data-turbo-eval", "false")
    document.head.appendChild(script)
    state.scriptLoaded = true
  }
}

function pageview() {
  if (currentConsent() !== "granted" || typeof window.gtag !== "function") return

  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href
  })
}

function clearGoogleCookies() {
  document.cookie.split("; ").forEach((row) => {
    const name = row.split("=")[0]
    if (name === "_ga" || name.startsWith("_ga_")) writeCookie(name, "", 0)
  })
}

function writeConsent(value) {
  state.consent = value
  writeCookie(state.consentCookie, value, CONSENT_MAX_AGE)
}

function cookieSuffix(maxAge) {
  const secure = window.location.protocol === "https:" ? "; Secure" : ""
  return `Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`
}

function writeCookie(name, value, maxAge) {
  document.cookie = `${name}=${encodeURIComponent(value)}; ${cookieSuffix(maxAge)}`
}

function readCookie(name) {
  if (!name) return ""

  const prefix = `${name}=`
  const match = document.cookie.split("; ").find((row) => row.startsWith(prefix))
  return match ? decodeURIComponent(match.slice(prefix.length)) : ""
}
